import * as React from "react";

import { useEffect, useState, Dispatch, SetStateAction } from "react";
import { FormComponentProps } from "antd/lib/form";
import { Row, Col } from "antd";
import { SelectCivilStatus } from "./SelectCivilStatus";
import { SelectPropertyRegime } from "./SelectPropertyRegime";
import { ITrade } from "src/services/interfaces/trade/ITrade";
import { EstadoCivilEnum } from "src/services/interfaces/trade/tradeOwner/EstadoCivilEnum";
import { ITradeOwner } from "src/services/interfaces/trade/tradeOwner/ITradeOwner";
import { PropertyRegimeEnum } from "src/services/interfaces/trade/tradeOwner/PropertyRegimeEnum";
import { needMariagePrenuptialAgreement, needMarriageCertificate, needMarriageDate, userHaveSpouse } from "src/util/Validations";
import ISpouse from "src/services/interfaces/ISpouse";
import FormItem from "antd/lib/form/FormItem";
import { PbrInputDate } from "src/components/common/PbrInputDate/PbrInputDate";
import { objectPropsUpdate } from 'src/util/objectUtils';
import { UploadDocumentButton } from 'src/components/Refatoracao/UploadDocument/UploadDocumentButton';
import { DocumentCategoryEnum } from 'src/components/Refatoracao/UploadDocument/DocumentCategoryEnum';
import { StorageTypeEnum } from 'src/components/Refatoracao/UploadDocument/StorageTypeEnum';

interface ICivilStatusProps extends FormComponentProps {
  trade: ITrade;
  setTrade: Dispatch<SetStateAction<ITrade>>;
  onChange: (value: Partial<ITradeOwner>) => void;
  setLoading: Dispatch<SetStateAction<boolean>>;
  isCivilStatusRequired: boolean
}

export const CivilStatus: React.FC<ICivilStatusProps> = ({
  trade,
  setTrade,
  onChange,
  setLoading,
  isCivilStatusRequired,
  form
}) => {
  const [showPropertyRegime, setShowPropertyRegime] = useState<boolean>(false);

  const isMarried = userHaveSpouse(trade);
  const labelCertificate = isMarried
    ? "Certidão de Casamento / União Estável "
    : trade.tradeOwner?.civilStatus === EstadoCivilEnum.viuvo
      ? "Certidão de óbito do conjuge"
      : "Certidão de Separação";

  const showCertificate = needMarriageCertificate(trade);
  const showMarriageDate = needMarriageDate(trade);
  const showPreNuptialAgreement = needMariagePrenuptialAgreement(trade);

  const subText = isMarried ? " Em caso de casamento após 1977, favor inserir um arquivo .zip com a certidão e o pacto antenupcial" : labelCertificate;

  const handleSpouseByPropertyRegimeChange = (value: ISpouse) => {
    setTrade((obj) => objectPropsUpdate(obj, {
      tradeOwner: objectPropsUpdate(obj.tradeOwner, {
        spouse: objectPropsUpdate(obj.tradeOwner.spouse, value)
      })
    }));
  };

  const setInitialSpouseByPropertyRegimeChange = () => {
    setTrade((obj) => objectPropsUpdate(obj, {
      tradeOwner: objectPropsUpdate(obj.tradeOwner, {
        spouse: objectPropsUpdate(obj.tradeOwner.spouse,
          {
            ...trade.tradeOwner.spouse,
            birthDate: null,
            cpf: null,
            email: null,
            fullName: null,
            nationality: null,
            profession: null,
            rg: null,
            rgState: null
          })
      })
    }));
  };

  useEffect(() => {
    const hasUnion = trade.tradeOwner?.civilStatus === EstadoCivilEnum.casado || trade.tradeOwner?.civilStatus === EstadoCivilEnum.uniao_estavel;
    setShowPropertyRegime(hasUnion);
    if (!hasUnion) {
      onChange({ propertyRegime: PropertyRegimeEnum.Indefinido });
    }
  }, [trade.tradeOwner?.civilStatus]);

  useEffect(() => {
    createSpouseByPropertyRegime();
  }, [trade.tradeOwner?.propertyRegime]);

  function changeCivilStatus(e: EstadoCivilEnum) {
    onChange({ civilStatus: e });
  }

  function changePropertyRegime(e: PropertyRegimeEnum) {
    onChange({ propertyRegime: e });
  }

  /**
   * When change in propertyRegime, populate spouse with object
   */
  function createSpouseByPropertyRegime() {
    if (userHaveSpouse(trade)) {
      if (trade.tradeOwner.spouse === null) {
        setInitialSpouseByPropertyRegimeChange();
      }
    } else {
      handleSpouseByPropertyRegimeChange(null);
    }
  }
  return (
    <>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={12} lg={12}>
          <SelectCivilStatus onChange={changeCivilStatus} tradeOwner={trade.tradeOwner} form={form} />
        </Col>

        <Col xs={24} sm={24} md={12} lg={12}>
          {showPropertyRegime && <SelectPropertyRegime tradeOwner={trade.tradeOwner} onChange={changePropertyRegime} form={form} />}
        </Col>


        {showMarriageDate &&
          <Col xs={24} sm={24} md={12} lg={12}>
            <PbrInputDate
              name="marriageDate"
              formWrapper={form}
              formItemProps={{ label: "Data de casamento" }}
              placeholder={"Informe a Resposta"}
              isRequired={isCivilStatusRequired}
              requiredMessage="Data de casamento obrigatório"
              value={trade.tradeOwner?.marriageDate}
              onChange={e => onChange({ marriageDate: e })}
              rules={[{ required: isCivilStatusRequired, message: "A data de casamento é obrigatória" }]}
            />
          </Col>
        }
        {showCertificate && (
          <Col xs={24} sm={24} md={12} lg={12}>
            <UploadDocumentButton
              trade={trade}
              setLoading={setLoading}
              title={labelCertificate}
              hoverText={subText}
              dontReloadTrade={true}
              hoverTextDisabled="Documento já enviado"
              uploadCategory={DocumentCategoryEnum.MARRIAGE_CERTIFICATE}
              storageType={StorageTypeEnum.S3}
            />
          </Col>
        )}
        {showPreNuptialAgreement && (
          <Col xs={24} sm={24} md={12} lg={12}>
            <FormItem label={"Para casamentos após 1977 o pacto antenupcial é obrigatório"}>
              <UploadDocumentButton
                trade={trade}
                setLoading={setLoading}
                title="Pacto antenupcial"
                dontReloadTrade={true}
                hoverTextDisabled="Documento já enviado"
                uploadCategory={DocumentCategoryEnum.MARRIAGE_PRENUPTIAL_AGREEMENT}
                storageType={StorageTypeEnum.S3}
              />
            </FormItem>
          </Col>
        )}
      </Row>
    </>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/TradeEdit/CivilStatus/CivilStatus.tsx